<ng-container *ngIf="alertStack">
    <div class="alert-container">
        <ng-container *ngFor="let alert of alertStack; let i = index">
            <div class="alert alert-item" [ngClass]="getAlertClass(alert)" @fadeInOut>
                <div class="alert-icon">
                    <mat-icon class="align-middle" aria-hidden="false" aria-label="alert-icon"
                        [fontIcon]="getIconName(alert)">
                    </mat-icon>
                </div>
                <div class="alert-message">{{ alert.message }}</div>
                <div class="alert-action">
                    <mat-icon class="align-middle" aria-hidden="false" aria-label="alert-icon" fontIcon="close"
                        (click)="closeAlert(i)">
                    </mat-icon>
                </div>
            </div>
        </ng-container>
    </div>
</ng-container>